import { Node } from '@tiptap/core';
import { mergeAttributes } from '@tiptap/react';
import markdownitContainer from 'markdown-it-container';

const Callout = Node.create({
  name: "callout",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: true,
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (node) => {
          const domNode = node;
          const role = domNode.getAttribute("data-role");
          return role === "callout" ? {} : false;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        ["data-role"]: "callout"
      }),
      0
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Shift-Mod-c": () => this.editor.commands.toggleCallout()
    };
  },
  addCommands() {
    return {
      setCallout: () => ({ commands }) => {
        return commands.wrapIn("callout");
      },
      toggleCallout: () => ({ commands }) => {
        return commands.toggleWrap("callout");
      },
      unsetCallout: () => ({ commands }) => {
        return commands.lift("callout");
      }
    };
  },
  addStorage() {
    return {
      markdown: {
        serialize(state, node) {
          state.write("::: callout\n");
          state.renderContent(node);
          state.write("\n:::\n");
          state.closeBlock(node);
        },
        parse: {
          setup(markdownit) {
            markdownit.use(markdownitContainer, "callout");
          }
        }
      }
    };
  }
});

export { Callout as default };
//# sourceMappingURL=Callout.js.map
